import {
  AddConsultantEventLogNoAnswerMutationVariables,
  GetPersonalInfoCardData,
  useAddConsultantEventLogNoAnswerMutation
} from "@bonliva-crm/graphql";
import { HookProps } from "../utils/hook-props";

export function useAddConsultantEventLogNoAnswer(props: HookProps) {
  const [addConsultantEventLogNoAnswerMutation] =
    useAddConsultantEventLogNoAnswerMutation({
      onError: (error) => {
        console.error(error);
        props.onError && props.onError(error);
      },
      onCompleted: (res) => {
        props.onCompleted && props.onCompleted(res.addConsultantNoanswerEvent?.event);
      }
    });

  const addConsultantEventLogNoAnswer = (
    args: AddConsultantEventLogNoAnswerMutationVariables
  ) => {
    props.onBeforeCall && props.onBeforeCall();
    addConsultantEventLogNoAnswerMutation({
      variables: args,
      refetchQueries: [GetPersonalInfoCardData.OperationName]
    });
  };

  return { addConsultantEventLogNoAnswer };
}
